import UseAxios from '../../../Api/http/http';
import { getPerformancePeriodDetails } from '../../../Api/request/performance';

export const fetchPerformamncePeriodDetails = async () => {
  try {
    const response = await UseAxios(getPerformancePeriodDetails());
    const result = response?.data?.performancePeriodDetails;

    return result;
  } catch (error) {
    return [];
  }
};

export const getUniqueYears = async (filterData) => {
  const uniqueYears = await filterData.reduce((acc, item) => {
    if (!acc.some(yearItem => yearItem.name === String(item.year))) {
      acc.push({ id: item.id, name: String(item.year) });
    }
    return acc;
  }, []);

  return uniqueYears;
};

export const getUniquePeriodNames = async (filterData) => {
  const uniquePeriodNames = await filterData.reduce((acc, item) => {
    if (!acc.some(periodItem => periodItem.name === item.cycleName)) {
      acc.push({ id: item.id, name: item.cycleName });
    }
    return acc;
  }, []);

  return uniquePeriodNames;
};
